<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="33">
          <div class="k-donut-chart-container-print-fix" style="height: 440px; width:1090px;">
            <kendo-chart [title]="labelTitle" *ngIf="chartsReady" (legendItemClick)="onLegendItemClick($event)" [transitions]="chartTransitionsEnabled">
              <kendo-chart-area background="white" height="420" width="1090"></kendo-chart-area>
              <kendo-chart-series gap="10">
                <kendo-chart-series-item type="waterfall"
                                         [data]="chartData"
                                         field="amount"
                                         categoryField="category"
                                         summaryField="summary"
                                         [spacing]="-1"
                                         [gap]="0.3"
                                         colorField="color">
                  <kendo-chart-series-item-labels format="n0" position="outsideEnd" [margin]="-3" background="transparent" font="12px Arial">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <!-- We need to display all the series in one, but need a legend for increase, decrease and totals. So, add 3 fake series here that don't do anything'-->
                <kendo-chart-series-item type="waterfall"
                                         name="{{'grossMarketRentToNetMarketRent.labelIncrease' | rdTranslate}}"
                                         [color]="colors.increase">
                </kendo-chart-series-item>
                <kendo-chart-series-item type="waterfall"
                                         name="{{'grossMarketRentToNetMarketRent.labelDecrease' | rdTranslate}}"
                                         [color]="colors.decrease">
                </kendo-chart-series-item>
                <kendo-chart-series-item type="waterfall"
                                         name="{{'grossMarketRentToNetMarketRent.labelTotal' | rdTranslate}}"
                                         [color]="colors.total">
                </kendo-chart-series-item>
              </kendo-chart-series>
              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item name="first" [min]="0">
                  <kendo-chart-value-axis-item-title font="12px Arial"></kendo-chart-value-axis-item-title>
                  <kendo-chart-value-axis-item-labels font="12px Arial"></kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>
              <kendo-chart-category-axis>
                <kendo-chart-axis-defaults>
                  <kendo-chart-axis-defaults-labels format="n0" font="12px Arial">
                  </kendo-chart-axis-defaults-labels>
                </kendo-chart-axis-defaults>
                <kendo-chart-category-axis-item [categories]="categories">
                  <kendo-chart-category-axis-item-labels font="12px Arial" rotation="auto" [padding]="3"></kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>
              <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="top" orientation="horizontal">
              </kendo-chart-legend>
            </kendo-chart>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
